export const Loading = () => {
  return (
    <div id="page-404">
      <div className="fof">
        <h1>Loading</h1>
      </div>
    </div>
  );
};
